export default "__VITE_ASSET__fdadda15__"